/**
 * addit Theme — Accordion Component
 * Smooth height animation for <details> elements
 */

(function () {
  'use strict';

  function initAccordions() {
    const groups = document.querySelectorAll('[data-accordion-group]');

    groups.forEach((group) => {
      const items = group.querySelectorAll('.accordion-item');

      items.forEach((item) => {
        const summary = item.querySelector('.accordion-item__header');
        const content = item.querySelector('.accordion-item__content');
        if (!summary || !content) return;

        summary.addEventListener('click', (e) => {
          e.preventDefault();

          if (item.open) {
            // Close animation
            const startHeight = item.offsetHeight;
            const endHeight = summary.offsetHeight;

            const animation = item.animate(
              { height: [startHeight + 'px', endHeight + 'px'] },
              { duration: 250, easing: 'ease-out' }
            );

            animation.onfinish = () => {
              item.open = false;
              item.style.height = '';
              item.style.overflow = '';
            };

            item.style.overflow = 'hidden';
          } else {
            // Open animation
            item.open = true;
            const startHeight = summary.offsetHeight;
            const endHeight = item.offsetHeight;

            item.animate(
              { height: [startHeight + 'px', endHeight + 'px'] },
              { duration: 250, easing: 'ease-out' }
            );
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initAccordions);
})();
